export enum UpperMenuType {
    Projects = 0,
    Routes = 1,
    Curves = 2,
    Validators = 3,
    Tilts = 4
  }